export default "__VITE_ASSET__UFA12w1P__"